module.exports = __webpack_public_path__ + "media/images/landkit/illustrations/illustration-2-5091302a70b6c74b64c103a851b56eae.png";